import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Select } from 'foundations-components/transitional/components/Select';
import { CustomizeLazyLoadingAttributesUrl, LazyLoadingTypes } from '../constants/shared';
import { jsx as _jsx } from "react/jsx-runtime";
function LazyLoadingInput({
  label,
  value,
  onChange
}) {
  const options = Object.keys(LazyLoadingTypes).map(loadingValue => ({
    text: I18n.text(`RichTextLib.lazyLoading.values.${loadingValue}`),
    value: loadingValue
  }));
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    tooltip: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "RichTextLib.lazyLoading.help",
      options: {
        learnMoreLink: /*#__PURE__*/_jsx(Link, {
          href: CustomizeLazyLoadingAttributesUrl,
          external: true,
          onMouseDown: evt => evt.preventDefault(),
          use: "on-dark",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "RichTextLib.shared.learnMore"
          })
        })
      }
    }),
    tooltipPlacement: "top",
    tooltipProps: {
      onMouseDown: evt => evt.preventDefault()
    },
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "lazy-loading-input",
      options: options,
      value: value,
      onChange: onChange
    })
  });
}
export default LazyLoadingInput;